import { render } from "./CoursesDetailsPage.vue?vue&type=template&id=e6d93bfe&ts=true"
import script from "./CoursesDetailsPage.vue?vue&type=script&lang=ts"
export * from "./CoursesDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__